import { useEffect, useReducer } from 'react';

import { useAddDxDialog } from '../adddxdialog';
import { useAddReasonOptionDialog } from '../addreasonoptiondialog';
import { useLookback } from '../lookback';
import * as ACTIONS from './actions';
import reducer from './reducer';
import wubs from '../../../services/popoutwub';

const initialState = {
  isLoading: false,
  statusMessage: '',
  details: {
    dateOfService: '',
    dxList: { listItems: [] },
    encounterCard: { encounterText: '' },
    encounterList: { items: [] },
    encounterId: 0,
    patientId: 0,
    reasonOptions: []
  }
};

const usePopoutCard = (service, encounterId) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const [lookbackState, lookbackActions] = useLookback();
  const [addDxDialogState, addDxDialogActions] = useAddDxDialog();
  const [
    addReasonOptionDialogState,
    addReasonOptionDialogActions
  ] = useAddReasonOptionDialog();

  const showLoading = msg => dispatch(ACTIONS.showLoading(msg));
  const hideLoading = () => dispatch(ACTIONS.hideLoading());
  const reloadEncounter = encId => {
    service.init(encId).then(responseJson => {
      dispatch(ACTIONS.initSuccess(responseJson));
    })
    .catch(e => dispatch(ACTIONS.initFailure(e.toString())));
  };

  const boundActions = {
    openAddDxDialog: addDxDialogActions.open,
    closeAddDxDialog: addDxDialogActions.close,
    openAddReasonOptionDialog: addReasonOptionDialogActions.open,
    closeAddReasonOptionDialog: addReasonOptionDialogActions.close,
    showLoading,
    hideLoading,
    showLookback: lookbackActions.show,
    hideLookback: lookbackActions.hide,
    setLookbackFilterValue: lookbackActions.setFilterValue,
    redirectToReviewDetails: () => {},
    reloadEncounter
  };

  // do init
  useEffect(() => {
    dispatch(ACTIONS.initRequest());

    service.init(encounterId)
    .then(responseJson => {
      dispatch(ACTIONS.initSuccess(responseJson));
    })
    .catch(e => dispatch(ACTIONS.initFailure(e.toString())));
  }, [encounterId]);

  // wub wub
  useEffect(() => {
    const refreshWubs = () => {
      if (!wubs.isInitialized) {
        wubs.init();
        wubs.setAsInitialized();
      }

      wubs.setEncodings(state.details.dxList.listItems);
      wubs.highlightEncodings(wubs.hexCodes);
      wubs.toggleExclusionHighlight();
    };

    requestAnimationFrame(refreshWubs);
  }, [
    state.details.dxList.listItems.length,
    lookbackState.isVisible,
    state.isLoading
  ]);

  const isPageLoading = (
    state.isLoading
  );

  const getStatusMessage = () => {
    const hasMessage = s => s.statusMessage.length > 0;

    return state.statusMessage;
  };

  return [
    {
      ...state,
      isLoading: isPageLoading,
      statusMessage: getStatusMessage(),
      lookback: lookbackState,
      addDxDialog: addDxDialogState,
      addReasonOptionDialog: addReasonOptionDialogState
    },
    boundActions
  ];
};

export default usePopoutCard;
